module.exports = __webpack_public_path__ + "img/pencil.8edee9eb.jpeg";